import React, { useState } from "react";
import { getCarLogoUrl } from "../../../utils/carLogoUtils";
import { Icons } from "../Icons";

interface CarBrandLogoProps {
  brand?: string | null;
  size?: number;
  className?: string;
  fallbackClassName?: string;
}

export const CarBrandLogo: React.FC<CarBrandLogoProps> = ({
  brand,
  size = 50,
  className = "",
  fallbackClassName = "bg-gradient-to-r from-orange-400 to-orange-600",
}) => {
  const [failed, setFailed] = useState(false);
  const logoUrl = getCarLogoUrl(brand);
  const showLogo = Boolean(brand?.trim() && logoUrl && !failed);

  if (!showLogo) {
    return (
      <div
        className={`flex-shrink-0 rounded-full flex items-center justify-center text-white ${fallbackClassName} ${className}`}
        style={{ width: size, height: size }}
      >
        <Icons.Car sx={{ fontSize: Math.round(size * 0.55), color: "white" }} />
      </div>
    );
  }

  return (
    <img
      src={logoUrl!}
      alt={brand ? `Logo ${brand}` : "Logo do veículo"}
      className={`flex-shrink-0 object-contain ${className}`}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
};
